import React, { useState } from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import { BasicImage, StandardContainer, PrismicImage } from "../../common"
import { VideoModal } from "../../common/videoComponents"

import PlayIcon from "../../../svg/play.svg"

const TestimonialWrapper = styled.div`
  background-color: #f3f3f3;
  .slider-control-centerleft,
  .slider-control-centerright {
    display: none;
  }
  .slider-control-bottomcenter {
    bottom: 20px !important;
  }
  .paging-dot {
    width: 12px !important;
    height: 12px !important;
  }
`

const Content = styled.div`
  max-width: ${(props) => props.theme.maxWidths.standard};
  margin: 0 auto;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  line-height: ${(props) => props.theme.lineHeight.body};
  color: ${(props) => props.theme.colors.textColor};
  span {
    max-width: ${(props) => props.theme.maxWidths.standard};
    display: block;
    margin: 20px auto;
    font-size: 0.8rem;
  }
  @media ${(props) => props.theme.breakpoints.ns} {
    font-size: 1.3rem;
    span {
      font-size: 1.2rem;
    }
  }
`

const StyledTestimonial = styled.div`
  padding: 4rem 2rem;
  text-align: center;
  @media ${(props) => props.theme.breakpoints.large} {
    padding: calc(20px + 160 * (100vw - 320px) / 2180)
      ${(props) => props.theme.wrappers.standard};
  }
`

const StyledMedia = styled.div`
  max-width: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 18 / 11;
  position: relative;
  overflow: hidden;
  margin: 0 auto 3rem auto;

  img {
    object-fit: cover;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`

const StyledPlayButton = styled.button`
  width: calc(100% - ${(props) => props.theme.padding.hMobile} * 2);
  height: 100%;
  position: absolute;
  padding: 0;
  top: 0;
  left: ${(props) => props.theme.padding.hMobile};
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
  > svg {
    width: 80px;
  }
  @media ${(props) => props.theme.breakpoints.medium} {
    width: calc(100% - ${(props) => props.theme.padding.hDesk} * 2);
    left: ${(props) => props.theme.padding.hDesk};
  }
`

const StyledVideoBlock = styled(StandardContainer)`
  position: relative;
  max-width: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 10 / 6;
  position: relative;
  overflow: hidden;
  margin: 0 auto 3rem auto;
`

const ScrollFreeze = `
  // html, body {
  //   margin: 0; 
  //   height: 100%; 
  //   overflow: hidden
  // }
`

const Testimonial = ({
  testimonial,
  name,
  video_url,
  image,
  link,
  link_colour,
  link_text,
}) => {
  const [video, setVideo] = useState(null)
  const videoObj = { url: video_url }
  return (
    <div>
      <StyledTestimonial>
        {video_url && (
          <>
            <style>{video ? ScrollFreeze : null}</style>
            <StyledVideoBlock>
              <StyledPlayButton onClick={() => setVideo(videoObj)}>
                <PlayIcon />
              </StyledPlayButton>
              {image && <PrismicImage {...image} />}
            </StyledVideoBlock>
            <VideoModal video={video} onClose={() => setVideo(null)} />
          </>
        )}
        {image?.url && !video_url && (
          <StyledMedia>
            <BasicImage {...image} />
          </StyledMedia>
        )}
        <Content>
          {testimonial?.text}
          <span style={{ fontWeight: "400" }}>{name?.text}</span>
          {link?.url && (
            <Link
              to={link?.url}
              className="styled-button"
              style={{ background: link_colour, margin: "2rem 0 0 0" }}
            >
              {link_text}
            </Link>
          )}
        </Content>
      </StyledTestimonial>
    </div>
  )
}

export const Testimonials = ({ items, anchor_id }) => {
  return (
    <TestimonialWrapper id={anchor_id}>
      <Testimonial {...items[0]} />
    </TestimonialWrapper>
  )
}
